<template>
  <div>
    <v-card class="pt-1" height="428px" flat>
      <div style="max-height: 374px; overflow: auto">
        <v-row no-gutters>
          <v-col class="px-2">
            <div class="title">
              <h5 class="ml-2">Comportamento</h5>
            </div>
            <v-divider class="mt-2 mb-2"/>
            <table class="ml-1">
              <tr>
                <chip v-if="itemMostrarDetalhes.feedback_comportamento === '00'" color="orange" icon="mdi-account-check" text="Cadastro Efetuado"/>
                <chip v-if="itemMostrarDetalhes.feedback_comportamento === '01'" color="green" icon="mdi-checkbox-marked-circle-outline" text="Finalizado Cliente"/>
                <chip v-if="itemMostrarDetalhes.feedback_comportamento === '02'" color="primary" icon="mdi-clipboard-check" text="Orçamento Gerado"/>
              </tr>
              <tr>
                <chip v-if="itemMostrarDetalhes.itens.length > 0" color="green" icon="mdi-cart" text="Adicionou no Carrinho"/>
                <chip v-else color="#a3a3a3" icon="mdi-cart" text="Carrinho Vazio"/>
              </tr>
              <tr>
                <span v-if="itemMostrarDetalhes.itens.length > 0">
                  <chip class="ml-5" v-if="itemMostrarDetalhes.feedback_imprimiu === 'S'" color="primary" icon="mdi-printer" text="Imprimiu Orçamento"/>
                  <chip class="ml-5" v-else color="#a3a3a3" icon="mdi-printer" text="Não Imprimiu"/>
                </span>
              </tr>
              <tr>
                <span v-if="itemMostrarDetalhes.itens.length > 0">
                  <chip class="ml-5" v-if="itemMostrarDetalhes.feedback_email === 'S'" color="primary" icon="mdi-email" text="Enviou por Email"/>
                  <chip class="ml-5" v-else color="#a3a3a3" icon="mdi-email" text="Não Enviou por Email"/>
                </span>
              </tr>
              <tr>
                <span v-if="itemMostrarDetalhes.itens.length > 0">
                  <chip class="ml-5" v-if="itemMostrarDetalhes.feedback_whatsapp === 'S'" color="primary" icon="mdi-whatsapp" text="Enviou por WhatsApp"/>
                  <chip class="ml-5" v-else color="#a3a3a3" icon="mdi-whatsapp" text="Não Enviou por WhatsApp"/>
                </span>
              </tr>
              <tr>
                <chip v-if="itemMostrarDetalhes.confirmado === 'S'" color="green" icon="mdi-gavel" text="Confirmado" :destaque="true"/>
                <chip v-else color="#a3a3a3" icon="mdi-thumb-down-outline" text="Não Confirmado"/>
                <chip v-if="itemMostrarDetalhes.feedback_comportamento === '03'" color="red" icon="mdi-emoticon-sad-outline" text="Cancelado Pelo Cliente"/>
              </tr>
              <tr v-if="itemMostrarDetalhes.confirmado === 'S'">
                <span>
                  <chip class="ml-5" v-if="itemMostrarDetalhes.confirmado_metodo === '01'" color="primary" icon="mdi-desktop-mac" text="Confirmado Através do Website"/>
                  <chip class="ml-5" v-if="itemMostrarDetalhes.confirmado_metodo === '02'" color="primary" icon="mdi-cellphone-iphone" text="Confirmado Através do Smartphone"/>
                  <chip class="ml-5" v-if="itemMostrarDetalhes.confirmado_metodo === '03'" color="primary" icon="mdi-account-box" text="Confirmado Através do Vendedor"/>
                </span>
              </tr>
              <tr v-if="itemMostrarDetalhes.confirmado === 'S'">
                <span>
                  <chip class="ml-5" v-if="itemMostrarDetalhes.confirmado_metodo === '01'" color="primary" icon="mdi-account-star" text="Confirmado pelo Próprio Cliente"/>
                  <chip class="ml-5" v-if="itemMostrarDetalhes.confirmado_metodo === '02'" color="primary" icon="mdi-account-star" text="Confirmado pelo Próprio Cliente"/>
                </span>
              </tr>
            </table>
            <!-- <v-divider class="my-3"/> -->
          </v-col>
          <v-col lg="4" class="px-2">
            <v-row no-gutters>
              <v-col>
                <h5 class="ml-2">Atendimento</h5>
                <v-divider class="mt-3 mb-1"/>
                <table>
                  <tr>
                    <chip class="ml-1" v-if="itemMostrarDetalhes.solicitou_contato_telefonico === 'S'" color="primary" icon="mdi-phone" text="Solicitou Contato Telefônico"/>
                  </tr>
                  <tr>
                    <chip class="ml-1" v-if="itemMostrarDetalhes.solicitou_contato_email === 'S'" color="primary" icon="mdi-email-outline" text="Solicitou Contato por Email"/>
                  </tr>
                  <tr>
                    <chip
                      v-if="itemMostrarDetalhes.solicitou_contato_telefonico !== 'S' && itemMostrarDetalhes.solicitou_contato_email !== 'S'"
                      text="Não Solicitou Contato"
                      icon="mdi-heart-broken"
                      color="#a3a3a3"
                      class="ml-1"
                    />
                  </tr>
                </table>
              </v-col>
              <v-row v-if="verificarArtes(itemMostrarDetalhes.itens)" class="mt-5" no-gutters>
                <v-col>
                  <h5 class="ml-2">Arte Enviada do Cliente</h5>
                  <v-divider class="my-3"/>
                  <v-row class="pl-1">
                    <span v-for="(item, index) in itemMostrarDetalhes.itens" :key="index">
                      <v-card v-if="item.arte_final" class="mx-2 mb-3" width="150px">
                        <a :href="getArteItem(item.arte_final)" target="_blank" download>
                          <v-img :src="getArteItem(item.arte_final)" style="height: 70px"></v-img>
                          <div class="mt-1 mb-1" style="font-size: 11px; color: gray; text-align: center">
                            {{ item.referencia }}
                          </div>
                        </a>
                      </v-card>
                    </span>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </v-col>
          <v-col class="px-2">
            <h5 class="ml-2">Temperatura</h5>
            <v-divider class="my-3"/>
            <v-card class="mt-4 ml-1 mr-2 mb-1" style="text-align: center" elevation="1" shaped>
              <v-card-actions class="ml-1">
                <v-row no-gutters>
                  <v-col style="max-width: 20px">
                    <v-btn class="mt-1" @click="alterarTemperatura('3')" icon>
                      <img style="width: 26px" :src="require('@/assets/temp3.svg')">
                    </v-btn><br>
                    <v-btn class="mt-1" @click="alterarTemperatura('2')" icon>
                      <img style="width: 26px" :src="require('@/assets/temp2.svg')">
                    </v-btn><br>
                    <v-btn class="mt-1" @click="alterarTemperatura('1')" icon>
                      <img style="width: 26px" :src="require('@/assets/temp1.svg')">
                    </v-btn>
                  </v-col>
                  <v-col>
                    <img class="fs-img-temp-carrinho" :src="require(`@/assets/temp${itemMostrarDetalhes.emotion}.svg`)">
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <v-card-actions style="padding: 0px; position: absolute; bottom: 0; left: 0;" class="mb-n3">
        <v-row v-if="itemMostrarDetalhes.feedback_comportamento !== '03'">
          <v-col align="start">
            <v-btn v-if="itemMostrarDetalhes.confirmado !== 'S'" color="green" @click="confirmarPedido" dark small>
              <v-icon class="mr-2" style="font-size: 15px !important">mdi-gavel</v-icon>
              Confirmar Pedido
            </v-btn>
            <v-btn v-if="itemMostrarDetalhes.confirmado !== 'S'" color="error" @click="abrirInteracao" class="ml-2" dark small>
              <v-icon class="mr-2" style="font-size: 15px !important">mdi-emoticon-sad-outline</v-icon>
              Não Comprou
            </v-btn>
            <v-btn v-if="itemMostrarDetalhes.confirmado === 'S'" color="#CCC" dark small>
              <v-icon class="mr-2" style="font-size: 15px !important">mdi-gavel</v-icon>
              Confirmar Pedido
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-actions style="padding: 0px; position: absolute; bottom: 0; right: 0" class="mb-n3">
        <v-row>
          <v-col align="end" justify="stretch" style="text-align: right;">
            <v-spacer></v-spacer>
            <v-btn color="warning" @click="fecharDialog()" dark small>
              <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogInteracao" max-width="700px">
      <v-card class="pa-3 pt-5" flat>
        <h3 class="ml-3">Adicionar Interação ao Pedido</h3>
        <v-divider style="margin: 17px 0px 12px 0px"></v-divider>
        <v-form autocomplete="off" class="mt-n2">
          <v-radio-group v-model="interacao.tipo" row>
            <v-radio color="#2A2F50" label="Envio de Email" value="Envio de Email"></v-radio>
            <v-radio color="#2A2F50" label="Contato Telefônico" value="Contato Telefônico"></v-radio>
            <v-radio color="#2A2F50" label="Feedback do Cliente" value="Feedback do Cliente"></v-radio>
          </v-radio-group>
          <v-textarea
            id="fs-textarea-descricao"
            label="Descrição *"
            placeholder=" "
            rows="8"
            spellcheck="false"
            class="mt-n3 mb-n5"
            v-model="interacao.descricao"
            outlined
          ></v-textarea>
        </v-form>
        <v-divider style="margin: 12px 0px 12px 0px"></v-divider>
        <v-card-actions style="padding: 0px">
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" @click="naoComprou()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Salvar
          </v-btn>
          <v-btn color="warning" @click="dialogInteracao = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import * as interacaoApi from '@/api/interacao'
import { edit, apiConfirmarPedido } from '@/api/carrinho.js'
import { mapState, mapMutations } from 'vuex'

require('dotenv').config()
export default {
  props: {
    itemMostrarDetalhes: Object,
    fecharDialog: Function
  },
  components: {
    chip: () => import('@/components/chip')
  },
  data () {
    return {
      loading: false,
      dialogInteracao: false,
      interacao: { descricao: '', tipo: 'Envio de Email' }
    }
  },
  computed: {
    ...mapState({
      confirm: state => state.global.confirm
    })
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    verificarArtes (itens) {
      return itens.find(x => {
        return x.arte_final
      })
    },
    getArteItem (arteFinal) {
      // return `${process.env.VUE_APP_BASE_URL}/site/getarteitem/${hash}`
      // return `${process.env.VUE_APP_BASE_URL_PUBLIC}/uploads/${arteFinal}`
      return arteFinal
    },
    async alterarTemperatura (value) {
      var color = 'green'
      if (value === '1') {
        color = 'red'
      } else if (value === '2') {
        color = '#B8B804'
      }
      if (await this.confirm.open('Alterar Temperatura', 'Tem certeza?', { color })) {
        try {
          await edit(this.itemMostrarDetalhes.id, { emotion: value })
          this.itemMostrarDetalhes.emotion = value
        } catch (error) {
        }
      }
    },
    async confirmarPedido () {
      this.loading = true
      var userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
      const text = `Deseja confirmar o pedido N° ${this.itemMostrarDetalhes.id.padStart(7, '0')}?`
      if (await this.confirm.open('Confirmar Pedido', text, { color: 'green' })) {
        try {
          var resposta
          if (this.itemMostrarDetalhes.vendedor_id) {
            resposta = await apiConfirmarPedido(this.itemMostrarDetalhes.id, { confirmado: 'S', confirmado_metodo: '03', emotion: '3', fase_id: 6 })
          } else {
            resposta = await apiConfirmarPedido(this.itemMostrarDetalhes.id, { confirmado: 'S', confirmado_metodo: '03', emotion: '3', fase_id: 6, vendedor_id: userInfo.pessoa })
          }

          if (resposta.success === true) {
            this.itemMostrarDetalhes.confirmado = 'S'
            this.itemMostrarDetalhes.confirmado_metodo = '03'
            this.itemMostrarDetalhes.emotion = '3'
            this.setSnackbar({ msg: 'Pedido Atualizado com Sucesso!', color: 'green' })
          } else {
            this.setSnackbar({ msg: 'Pedido NÃO confirmado: ' + resposta.msg, color: 'red' })
          }
        } catch (error) {
          // console.log(error)
          this.setSnackbar({ msg: 'Erro -> Pedido NÃO confirmado!', color: 'red' })
        }
        this.loading = false
      }
    },
    async abrirInteracao () {
      this.interacao.descricao = ''
      this.interacao.tipo = 'Envio de Email'
      this.dialogInteracao = true
    },
    async naoComprou () {
      if (this.interacao.descricao.length > 0) {
        this.dialogInteracao = false
        if (await this.confirm.open('Não Comprou', 'Deseja marcar esse pedido como não comprado?', { color: 'red' })) {
          const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
          const data = {
            ecommerce_carrinho_id: this.itemMostrarDetalhes.id,
            usuario_id: userInfo.pessoa,
            cliente_id: this.itemMostrarDetalhes.pessoa_id,
            tipo: this.interacao.tipo,
            descricao: this.interacao.descricao
          }
          try {
            await interacaoApi.add({}, data)
            if (this.itemMostrarDetalhes.vendedor_id) {
              await edit(this.itemMostrarDetalhes.id, { emotion: '1', fase_id: 4, feedback_comportamento: '03' })
            } else {
              await edit(this.itemMostrarDetalhes.id, { emotion: '1', fase_id: 4, feedback_comportamento: '03', vendedor_id: userInfo.pessoa })
            }
            this.setSnackbar({ msg: 'Pedido Atualizado com Sucesso!', color: 'green' })
            this.itemMostrarDetalhes.feedback_comportamento = '03'
            this.itemMostrarDetalhes.fase_id = 4
            this.itemMostrarDetalhes.emotion = '1'
          } catch (error) {
            this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
          }
        } else {
          this.dialogInteracao = true
        }
      } else {
        this.setSnackbar({ msg: 'Informe a Descrição da Interação!' })
      }
    }
  }
}
</script>

<style scoped>
  /* .title {
    width: 100%;
    text-align: center;
  } */
  h5 {
    font-size: 14px;
    text-transform: uppercase !important;
    color: rgb(45, 49, 85);
  }
  .fs-box-metodo-confirm {
    margin-top: 5px;
    padding: 5px;
    /* border: 1px solid #CCC; */
    text-align: center;
  }
  .fs-box-metodo-confirm > span {
    color: rgb(45, 49, 85);
    font-size: 11px;
    font-weight: 500;
  }
  .fs-img-temp-carrinho {
    padding-top: 3px;
    width: 110px;
  }
</style>
